import {
  deleteAlimento as axiosDeleteAlimento,
  getAlimentos as axiosGetAlimentos,
  getAlimentosByMascota as axiosGetAlimentosByMascota,
  postAlimento as axiosPostAlimento,
  updateAlimento as axiosUpdateAlimento,
} from '../../axios/Alimentacion-Pesaje';
import { postPesaje as axiosPostPesaje } from '../../axios/Alimentacion-Pesaje';
import { GET_FOOD_BAGS, GET_FOOD_PET } from '../../axios/Utils/constants';
import {
  AlimentoByMascota,
  AlimentoReq,
  FetchAlimento,
  UpdateAlimento,
} from '../../types/Alimentacion-Pesaje/types';
import { PesajeReq } from '../../types/Alimentacion-Pesaje/types';
import { useCreateEntity, useFetchEntity } from '../Utils/useEntity';

const useGetAlimentos = () => {
  const { data, error, isValidating, mutate } = useFetchEntity<FetchAlimento[]>(
    GET_FOOD_BAGS,
    axiosGetAlimentos,
  );

  const marcasAlimento = data ? Array.from(new Set(data.map((item) => item.marca))) : [];

  return { alimentos: data, marcasAlimento, isValidating, error, mutate };
};

const useGetAlimentosByMascota = (id?: string) => {
  const { data, error, isValidating, mutate } = useFetchEntity<AlimentoByMascota[]>(
    id ? `${GET_FOOD_PET}/${id}` : null,
    () => axiosGetAlimentosByMascota(id),
  );

  return { alimentosByMascota: data, isValidating, error, mutate };
};

const usePostAlimento = () => {
  const { create, isLoading, error } = useCreateEntity<AlimentoReq, boolean>(
    axiosPostAlimento,
  );

  return { postAlimento: create, isLoading, error };
};

const useUpdateAlimento = () => {
  const { create, isLoading, error } = useCreateEntity<UpdateAlimento, boolean>(
    axiosUpdateAlimento,
  );

  return { updateAlimento: create, isLoading, error };
};

const useDeleteAlimento = () => {
  const { create, isLoading, error } = useCreateEntity<number, boolean>(
    axiosDeleteAlimento,
  );

  return { deleteAlimento: create, isLoading, error };
};

const usePostPesaje = () => {
  const { create, isLoading, error } = useCreateEntity<PesajeReq, boolean>(
    axiosPostPesaje,
  );

  return { postPesaje: create, isLoading, error };
};

export {
  useGetAlimentos,
  useGetAlimentosByMascota,
  usePostAlimento,
  useUpdateAlimento,
  useDeleteAlimento,
  usePostPesaje,
};
